module.exports = __webpack_public_path__ + "static/media/chess-knight.bb2b666d.svg";